module.exports = __webpack_public_path__ + "img/company-logo-white.8768bfb6.svg";